import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NebisTalepBilgiler } from 'src/app/models/nebisTalep.model';
import { KullaniciTalepService } from 'src/app/services/kullanici-talep.service';

@Component({
  selector: 'kullanici-talep-ayrinti',
  templateUrl: './kullanici-talep-ayrinti.component.html',
  styleUrls: ['./kullanici-talep-ayrinti.component.css']
})
export class KullaniciTalepAyrintiComponent implements OnInit {

  constructor(private router: Router, public kullaniciTalepService: KullaniciTalepService, private route: ActivatedRoute) { }
  kullaniciTalepNebis: NebisTalepBilgiler = new NebisTalepBilgiler();
  yukleniyor = true;
  dosyaAd: string = "";
  fileUrl: string = "";
  indiriliyor: boolean = false;
  indiriliyorHar: boolean = false;
  haraketRenk: any[] = [
    { id: 0, renk: "warning" },
    { id: 1, renk: "success" },
    { id: 2, renk: "danger" },
    { id: 3, renk: "primary" },
    { id: 4, renk: "" }
  ];

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.getById(params['id']);
      }
    });
  }

  getById(id: number) {
    this.kullaniciTalepService.getNebisById(id).subscribe(res => {
      this.kullaniciTalepNebis = res.data;
      this.yukleniyor = false;
     
      if (this.kullaniciTalepNebis == null) {
        this.router.navigateByUrl('/');
      }
      if (this.kullaniciTalepNebis?.dosya.length > 0) {
        this.kullaniciTalepService.dosyaBilgi(this.kullaniciTalepNebis?.dosya).subscribe(res => {
          this.dosyaAd = res.data?.dosyaAd;
        })
      }
    }, err => {
      this.yukleniyor = false;
      this.router.navigateByUrl('/')
    });

  }

  // dosyaAdGetir(talepID: number, hareketID: number): string {
  //   this.kullaniciTalepService.dosyaIndirNebis(talepID, hareketID).subscribe(res => {
  //     this.dosyaAd=res.data.fileName;
  //   });
  //   return this.dosyaAd;
  // }

  dataURItoBlob(dataURI: string) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array]);
    return blob;
  }

  dosyaIndirNebis(talepID: number, hareketID: number) {
    if (this.indiriliyor) return;
    if (hareketID != 0) {
      this.indiriliyorHar = true;
    }
    else this.indiriliyor = true;

    this.kullaniciTalepService.dosyaIndirNebis(talepID, hareketID).subscribe(res => {
      var blob = this.dataURItoBlob(res.data.fileBase64Data);
      const imageFile = new File([blob], res.data.fileName, { type: res.data.contentType });
      var objectUrl = URL.createObjectURL(imageFile);
      var fileLink = document.createElement('a');
      fileLink.href = objectUrl;
      fileLink.download = res.data.fileName;
      fileLink.click();
      this.indiriliyor = false;
      this.indiriliyorHar = false;
    });
  }





}
